import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';

/**
 * Botón para cargar todos los vigilantes
 * @param {Object} props - Propiedades del componente
 * @param {Function} props.onClick - Función a ejecutar al hacer clic
 * @param {boolean} props.isLoading - Estado de carga
 * @returns {JSX.Element}
 */
const LoadAllButton = ({ onClick, isLoading }) => {
  return (
    <Button
      variant="outlined"
      onClick={onClick}
      disabled={isLoading}
      startIcon={isLoading ? <CircularProgress size={20} /> : <PeopleAltIcon />}
      sx={{
        marginLeft: '10px',
        backgroundColor: 'white',
        color: '#4678c3',
        border: '1px solid #4678c3',
        '&:hover': {
          backgroundColor: '#eef2f7',
          borderColor: '#4678c3'
        }
      }}
    >
      {isLoading ? 'Cargando...' : 'Mostrar todos los usuarios'}
    </Button>
  );
};

export default LoadAllButton;